import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "../../../../store/api";
import { AppThunk } from "../../../../store/app";
import Config from "../../../../config/Config";
import { apiUrls } from "./apiUrls";

interface InitialState {
  isLoading: boolean;
  agGrid: any;
  rowData: any;
  fileRowdata: any;
  perPage: any;
  details: any;
}

const initialState = {
  isLoading: false,
  agGrid: null,
  fileRowdata: null,
  rowData: null,
  perPage: Config.grid.server.gridOptions?.paginationPageSize,
  details: null,
} as InitialState;

const importActivitySlice = createSlice({
  name: "import_activity",
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
    },
    failure: (state) => {
      state.isLoading = false;
    },
    setRowData: (state, action: PayloadAction<any>) => {
      state.rowData = action?.payload;
    },
    setGrid: (state, action: PayloadAction<any>) => {
      state.agGrid = action?.payload;
    },
    setPerPage: (state, action: PayloadAction<any>) => {
      state.perPage = action?.payload;
      if (state.agGrid) {
        state.agGrid.api.paginationSetPageSize(Number(state.perPage));
        state.agGrid.api.setCacheBlockSize(state.perPage);
      }
    },
    setDetails: (state, action: PayloadAction<any>) => {
      state.details = action?.payload;
    },
    setFileRowData: (state, action: PayloadAction<any>) => {
      state.fileRowdata = action?.payload;
    },
  },
});

export const {
  start,
  success,
  setFileRowData,
  failure,
  setGrid,
  setRowData,
  setPerPage,
  setDetails,
} = importActivitySlice.actions;

// /** For Listing:Start */
export const fetchList =
  (requestData?: any): AppThunk<any> =>
    async (dispatch) => {
      try {
        dispatch(start());
        dispatch(setRowData([]));
        console.log('requestData',requestData)
        // const response = await api.get(apiUrls.list);
        const response = await api.post(apiUrls.list,requestData);
        dispatch(setRowData(response.data.rows));
        dispatch(success());
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(failure());
        return Promise.reject(error.data);
      }
    };



export const details =
  (id: number): AppThunk<any> =>
    async (dispatch) => {
      try {
        const response = await api.get(apiUrls.details(id));
        dispatch(setDetails(response.data.data));
        dispatch(setFileRowData(response?.data?.data?.payload || []));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };
// /** For Listing:End */

const importActivityReducer = importActivitySlice.reducer;
export default importActivityReducer;
